module.exports = __webpack_public_path__ + "imgs/Rosie1.png";